import { Controller } from "@hotwired/stimulus"

const LABELS = ["", "Poor", "Fair", "Good", "Very Good", "Excellent"]

// Connects to data-controller="star-rating"
// Expects:
//   data-star-rating-value-value  — current integer rating (0 = none)
//   a hidden input with data-star-rating-target="input"
//   star buttons with data-star-rating-target="star" and data-star-rating-index-param
//   a label element with data-star-rating-target="label"
//   optionally a form with data-star-rating-target="form" to auto-submit on click
export default class extends Controller {
  static targets = ["input", "star", "label", "form"]
  static values = { value: Number }

  connect() {
    this.render(this.valueValue)
  }

  rate(event) {
    const rating = parseInt(event.params.index, 10)
    this.valueValue = rating
    this.inputTarget.value = rating
    this.render(rating)
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }

  hover(event) {
    this.render(parseInt(event.params.index, 10), true)
  }

  reset() {
    this.render(this.valueValue)
  }

  render(rating, hovering = false) {
    this.starTargets.forEach((star, i) => {
      const filled = i < rating
      star.classList.toggle("text-custom-yellow-light", filled)
      star.classList.toggle("text-custom-yellow", !filled)

      // Toggle fill/stroke on the lucide SVG element inside the button
      const svg = star.querySelector("svg")
      if (svg) {
        svg.classList.toggle("fill-custom-yellow", filled)
        svg.classList.toggle("stroke-custom-yellow", filled)
        svg.classList.toggle("fill-none", !filled)
        svg.classList.toggle("stroke-current", !filled)
      }
    })
    this.labelTarget.textContent = LABELS[rating] || ""
    this.labelTarget.classList.toggle("text-custom-yellow", rating > 0 && !hovering)
    this.labelTarget.classList.toggle("text-neutral-600", rating === 0 || hovering)
  }
}
